import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=dd9d356c&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=dd9d356c&prod&scoped=true&lang=css"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=dd9d356c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d356c",
  null
  
)

export default component.exports